import { Grid, Stack } from "@mui/material";
import { useEffect } from "react";
import NavBar from "../../components/NavBar";
import Footer from "../../components/landing/Footer";
import MainAboutUsSection from "../../components/about/MainAboutUsSection";
import MissionSection from "../../components/about/MissionSection";
import CoreValueSection from "../../components/about/CoreValueSection";
import TeamSection from "../../components/about/TeamSection";

const AboutUs = () => {
    useEffect(() => {
        document.title = "Majura - Reimagining Logistics for the Digital Age";
    }, []);

    return (
        <div style={{ width: "100vw", height: "100%" }}>
            <Grid container spacing={0} style={{ width: "100%", height: "100%" }}>
                <Grid size={{ xs: 12 }}>
                    <NavBar isSticky={false} bgColor={'transparent'} />

                    <main>
                        <Stack
                            direction={"column"}
                            spacing={{ xs: '100px', sm: "50px" }}
                            style={{ width: "100%" }}
                        >
                            <MainAboutUsSection />

                            <MissionSection />

                            <CoreValueSection />

                            <TeamSection />
                        </Stack>
                    </main>

                    <footer style={{ marginTop: '-200px' }}>
                        <Footer />
                    </footer>
                </Grid>
            </Grid>
        </div>
    );
};

export default AboutUs;